import { useState } from "react";
import { isMobile } from "react-device-detect";

import { MdClear } from "react-icons/md";
import ziellogo from "../ZielLogo.png";

const Navbar = (props) => {
  const { scrolled } = props;
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <div
      className={
        isMobile
          ? "navbarcontainer"
          : scrolled
          ? "navbarcontainer scrollednav"
          : "navbarcontainer"
      }
    >
      {isMobile && (
        <>
          <div
            className="mobilemenucontainer"
            onClick={() => setShowMobileMenu(true)}
          >
            <div className="menutop"></div>
            <div className="menumiddle"></div>
            <div className="menubottom"></div>
          </div>
          <div
            className={showMobileMenu ? "mobilemenu" : "mobilemenu hidemenu"}
          >
            <button onClick={() => setShowMobileMenu(false)}>
              <MdClear />
            </button>
            <a href="#services" onClick={() => setShowMobileMenu(false)}>
              WHAT WE DO
            </a>
            <a href="#about" onClick={() => setShowMobileMenu(false)}>
              ABOUT ZIEL
            </a>
            <a href="#contact" onClick={() => setShowMobileMenu(false)}>
              CONTACT
            </a>
          </div>
        </>
      )}
      <div
        className={scrolled ? "logocontainer scrolledlogo" : "logocontainer"}
      >
        <img src={ziellogo} alt="" />
      </div>
      {!isMobile && (
        <ul>
          <li>
            <a href="#services">WHAT WE DO</a>
          </li>
          <li>
            <a href="#about">ABOUT ZIEL</a>
          </li>
          <li>
            <a href="#contact">CONTACT</a>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Navbar;
